import { useEffect, useState } from "react";
import ArticleCategoryOrder from "../components/articles/ArticleCategoryOrder"
import ArticleCategoryForm from "../components/form/ArticleCategoryForm"
import { ARTICLE_CATEGORY_URL } from '../contexts/PageProvider';

const submitUrl = 'article/category'
const ArticleCategoryPage = ({articles, getArticleList}) => {
  const [catUpdated, setCatUpdated] = useState(false);  
  const [listArticles, setListArticles] = useState(articles);

  useEffect(() => { 
    setListArticles(articles);
}, [articles]); 

  return (
    <>
      <ArticleCategoryForm submitUrl={ARTICLE_CATEGORY_URL} setCatUpdated={setCatUpdated} />
      <ArticleCategoryOrder {...{catUpdated, setCatUpdated, listArticles, getArticleList}}/>
    </>
  )
}

export default ArticleCategoryPage